import React, { } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import Categories from './Categories';
import Layers from '../Layers';

const SelectDescribe:React.FC<IProps> = (props) => {
  
  return (
    <S.Root>
      <Categories/>
      <S.LayersContainer>
        <Layers/>
      </S.LayersContainer>
    </S.Root>
  );
}

export default SelectDescribe;